/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Preset_Manager_Tab_SubtitlesInputs */

const en_preset_manager_tab_subtitles = /** @type {(inputs: Preset_Manager_Tab_SubtitlesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subtitles`)
};

const fr_preset_manager_tab_subtitles = /** @type {(inputs: Preset_Manager_Tab_SubtitlesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sous-titres`)
};

const de_preset_manager_tab_subtitles = /** @type {(inputs: Preset_Manager_Tab_SubtitlesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Untertitel`)
};

const it_preset_manager_tab_subtitles = /** @type {(inputs: Preset_Manager_Tab_SubtitlesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sottotitoli`)
};

const ru_preset_manager_tab_subtitles = /** @type {(inputs: Preset_Manager_Tab_SubtitlesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Субтитры`)
};

const es_preset_manager_tab_subtitles = /** @type {(inputs: Preset_Manager_Tab_SubtitlesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subtítulos`)
};

const zh_cn2_preset_manager_tab_subtitles = /** @type {(inputs: Preset_Manager_Tab_SubtitlesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`字幕`)
};

const ja_preset_manager_tab_subtitles = /** @type {(inputs: Preset_Manager_Tab_SubtitlesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`字幕`)
};

const hi_preset_manager_tab_subtitles = /** @type {(inputs: Preset_Manager_Tab_SubtitlesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`उपशीर्षक`)
};

const pt_pt2_preset_manager_tab_subtitles = /** @type {(inputs: Preset_Manager_Tab_SubtitlesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legendas`)
};

/**
* | output |
* | --- |
* | "Subtitles" |
*
* @param {Preset_Manager_Tab_SubtitlesInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const preset_manager_tab_subtitles = /** @type {((inputs?: Preset_Manager_Tab_SubtitlesInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Preset_Manager_Tab_SubtitlesInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_preset_manager_tab_subtitles(inputs)
	if (locale === "de") return de_preset_manager_tab_subtitles(inputs)
	if (locale === "it") return it_preset_manager_tab_subtitles(inputs)
	if (locale === "ru") return ru_preset_manager_tab_subtitles(inputs)
	if (locale === "es") return es_preset_manager_tab_subtitles(inputs)
	if (locale === "zh-CN") return zh_cn2_preset_manager_tab_subtitles(inputs)
	if (locale === "ja") return ja_preset_manager_tab_subtitles(inputs)
	if (locale === "hi") return hi_preset_manager_tab_subtitles(inputs)
	if (locale === "pt-PT") return pt_pt2_preset_manager_tab_subtitles(inputs)
	return en_preset_manager_tab_subtitles(inputs)
});